import React, { Component } from 'react'
import styled from 'styled-components'

const HiSpan = styled.span`
  background-color: yellow;
  color: #222;
  font-weight: bold;
`

const getHighlightedText = (text, higlight) => {
  // Split on higlight term and include term into parts, ignore case
  let parts = text.split(new RegExp(`(${higlight})`, 'gi'))
  return (
    <span>
      {' '}
      {parts.map(
        (part, i) =>
          part.toLowerCase() === higlight.toLowerCase() ? (
            <HiSpan key={i}>{part}</HiSpan>
          ) : (
            part
          )
      )}{' '}
    </span>
  )
}

export class TreeHeader extends Component {
  render() {
    const { node, style } = this.props
    let dispName = <span>{node.name}</span>
    if (node.filter && node.filter.length > 0) {
      dispName = getHighlightedText(node.name, node.filter)
    }
    return (
      <div style={style.base}>
        <div style={style.title}>{dispName}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/company-hierarchy/treecustom.js